import { useCallback, useState } from 'react';
import { useIsMounted } from './useIsMounted';

export function useSafeState(initialState) {
  const [state, setState] = useState(initialState);
  const isMounted = useIsMounted();

  const safeSetState = useCallback((newValue) => {
    if (isMounted()) {
      setState(newValue);
    }
  }, [isMounted]);

  return [state, safeSetState];
}
